/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Universal match status applicable to all competition types
 * @export
 */
export const CompetitionMatchStatus = {
    SCHEDULED: 'SCHEDULED',
    READY: 'READY',
    IN_PROGRESS: 'IN_PROGRESS',
    AWAITING_CONFIRMATION: 'AWAITING_CONFIRMATION',
    DISPUTED: 'DISPUTED',
    COMPLETED: 'COMPLETED',
    CANCELLED: 'CANCELLED',
    FORFEIT: 'FORFEIT'
} as const;
export type CompetitionMatchStatus = typeof CompetitionMatchStatus[keyof typeof CompetitionMatchStatus];


export function instanceOfCompetitionMatchStatus(value: any): boolean {
    for (const key in CompetitionMatchStatus) {
        if (Object.prototype.hasOwnProperty.call(CompetitionMatchStatus, key)) {
            if (CompetitionMatchStatus[key as keyof typeof CompetitionMatchStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CompetitionMatchStatusFromJSON(json: any): CompetitionMatchStatus {
    return CompetitionMatchStatusFromJSONTyped(json, false);
}

export function CompetitionMatchStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitionMatchStatus {
    return json as CompetitionMatchStatus;
}

export function CompetitionMatchStatusToJSON(value?: CompetitionMatchStatus | null): any {
    return value as any;
}

export function CompetitionMatchStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): CompetitionMatchStatus {
    return value as CompetitionMatchStatus;
}

